'use strict';
const _ = require('underscore');
const Moment = require('moment');
const Backbone = require('backbone');
const Key = require('common/domain/value/key');
const RelatedKeys = require('common/domain/value/related-keys');
const CommentReactionCollection = require('communication/domain/comment-reaction/reaction-collection');

module.exports = Backbone.Model.extend({
    defaults: {
        revision: null,
        createdAt: null,
        body: '',
        tasks: null,
        relatedKeys: null,
        userIDs: null,
        replyTo: null,
        replyComments: null,
        _isActive: false,
        _reactions: [],
        _project: null
    },

    initialize: function() {
        this._replyComments = new Backbone.Collection(
            [], {
                model: this.constructor,
                comparator: function(item) {
                    return item.getUpdatedAt();
                }
            });
        this._replyComments.on('add', () => {
            this.trigger('change:replyComments');
        });

        this._showReplyComments = true;
        this.listenTo(this._replyComments, 'active', this.replyActive);

        this._reactions = new CommentReactionCollection(this.get('reactions'), {
            comment: this
        });
        this._reactions.on('change', () => {
            this.trigger('change:reactions');
        });
    },

    replyActive: function(model) {
        this.trigger('active:reply', model);
    },

    _setActive: function(active) {
        this.set({_isActive: active});
    },

    activate: function() {
        this._setActive(true);
        this.trigger('active', this);
    },

    deactivate: function() {
        this._setActive(false);
        this.trigger('inactive', this);
    },

    isActive: function() {
        return this.get('_isActive');
    },

    getKey: function() {
        return new Key(this.get('key'));
    },

    getProject: function() {
        return this.get('_project');
    },

    getAuthor: function() {
        return this.get('author');
    },

    getBody: function() {
        return this.get('body');
    },

    getReplyComments: function() {
        return this._replyComments;
    },

    addReplyComment: function(comment) {
        this._replyComments.add(comment);
    },

    abbreviateReplyComments: function() {
        this._showReplyComments = false;
    },

    showReplyComments: function() {
        this._showReplyComments = true;
    },

    isShowReplyComments: function() {
        return this._showReplyComments;
    },

    getActiveReplyComments: function() {
        return this.getReplyComments().filter(c => c.isActive());
    },

    getReplyTo: function() {
        return this.get('replyTo');
    },

    getTaskIds: function() {
        // attributes の tasks にはタスクのID配列が入っているので、そのまま帰す
        return this.get('tasks');
    },

    getPrimaryRelatedKey: function() {
        return this.getRelatedKeys().primaryKey;
    },

    getReactions: function() {
        return this._reactions;
    },

    hasReaction: function(reactionName, userKey) {
        return this._reactions.hasReaction(reactionName, userKey);
    },

    addReaction: function(reactionName, userKey, actionAt = null) {
        this._reactions.addReaction(reactionName, userKey, actionAt);
    },

    removeReaction: function(reactionName, userKey) {
        this._reactions.removeReaction(reactionName, userKey);
    },

    /**
     * 指定された key が RelatedKeys に含まれる場合と、
     * key が Project の key の場合に true を返す。
     *
     * @param key
     */
    isRelatedTo: function(key) {
        if(key.isEqual(this.key.parent)) {
            return true;
        }

        return this.getRelatedKeys().contains(key);
    },

    getRelatedKeys: function() {
        const keys = _.map(this.get('relatedKeys'), k => new Key(k));
        return new RelatedKeys(keys);
    },

    filterRelatedKeysByKind: function(kind) {
        return this.getRelatedKeys().getKeysByKind(kind);
    },

    getCreatedAt: function() {
        return Moment(this.get('createdAt'));
    },

    getUpdatedAt: function() {
        return Moment(this.get('updatedAt'));
    },

    getMentionTo: function() {
        return this.get('userIDs');
    },

    isNotEmpty: function() {
        return this.get('body') || this.getRelatedKeys().length || this.get('replyTo') || this.get('userIDs').length;
    }
});



// WEBPACK FOOTER //
// ./communication/domain/entity/comment.js